export default {
  nav: {
    dashboard: "Dashboard",
    businesses: "Businesses",
    whatsapp: "WhatsApp",
    agency: "Mis Subcuentas",
    agents: "Agents",
    knowledge: "Knowledge Base",
    workflows: "Workflows",
    conversations: "Conversations",
    users: "Users",
    saasAdmin: "SaaS Admin",
    settings: "Configuración",
    support: "Soporte",
    logout: "Cerrar sesión",
  },
  auth: {
    welcome: "Bienvenido de nuevo",
    signInSub: "Inicia sesión en tu cuenta",
    email: "Correo electrónico",
    password: "Contraseña",
    signIn: "Iniciar sesión",
    signingIn: "Iniciando sesión...",
    fillFields: "Completa todos los campos",
    loginFailed: "Error al iniciar sesión",
    noAccount: "¿No tienes cuenta?",
    createOne: "Crea una",
    step1Title: "Paso 1 · Elige tu plan",
    step1Sub: "Ambos incluyen 7 días de prueba gratis — se pide tarjeta, no se cobra hasta el día 8.",
    step2Title: "Paso 2 · Crea tu cuenta",
    step2Sub: "Solo falta crear tu cuenta. Usa el mismo correo con el que pagaste.",
    paidBanner: "Pago recibido — crea tu cuenta",
    paidBannerSub: "Tu plan se activó. Usa el mismo correo del pago para que lo reconozcamos automáticamente.",
    name: "Nombre",
    confirmPassword: "Confirmar contraseña",
    createAccount: "Crear mi cuenta",
    creating: "Creando cuenta...",
    alreadyPaid: "Ya pagué mi plan — crear mi cuenta",
    firstPlan: "Primero elige tu plan en el Paso 1",
    firstPlanSub: "La cuenta se crea después del pago. Si ya compraste en otra pestaña, continúa aquí:",
    loginInstead: "¿Ya tienes cuenta? Inicia sesión",
    perMonth: "USD/mes",
    fullName: "Nombre completo",
    emailPaid: "Correo (el mismo del pago)",
    haveAccount: "¿Ya tienes cuenta?",
    tryFree: "Probar 7 días gratis",
    toastPwdMismatch: "Las contraseñas no coinciden",
    toastPwdShort: "La contraseña debe tener al menos 6 caracteres",
    toastCreated: "¡Cuenta creada! Bienvenido a LeadBot",
    namePh: "Juan Pérez",
  },
  dash: {
    title: "Dashboard",
    tagline: "We make your life easier",
    subtitle: "Resumen de tu operación con IA",
    businesses: "Negocios",
    activeLocations: "Ubicaciones activas",
    activeAgents: "Agentes activos",
    conversations: "Conversaciones",
    leads: "Leads calificados",
    appointments: "Citas",
    activeBusinesses: "Negocios activos",
    crmConnected: "CRM conectado",
    noCrm: "Sin CRM",
    planCard: "Tu plan y créditos de IA",
    trialing: "Prueba gratis",
    active: "Activo",
    suspended: "Suspendido",
    trialEnds: "termina el {{date}}",
    aiMonth: "Respuestas de IA este mes",
    packBalance: "Paquetes IA: {{count}} respuestas restantes de tus paquetes (se consumen cuando terminas lo incluido del mes).",
    limitReached: "Llegaste a tu tope — compra un paquete o conecta tu propia llave de IA en Configuración del número.",
    buyNumber: "+ Número extra",
    buySub: "+ Subcuenta extra",
    buyCredits: "+ Créditos IA",
  },
  wa: {
    subtitle: "Gestiona tus conexiones de WhatsApp",
    docs: "Documentación",
    commands: "Comandos",
    addWhatsapp: "Añadir WhatsApp",
    ghlBanner: "Conecta tu GoHighLevel. Tu WhatsApp puede conectarse, pero los mensajes no llegarán a tu CRM hasta que vincules tu subcuenta. Es un clic: autorizas la app y se vincula sola.",
    connectNow: "Conectar ahora",
    totalConnections: "Total Conexiones",
    active: "Activas",
    disconnected: "Desconectadas",
    connectedNumbers: "Números Conectados",
    connectedNumbersSub: "Gestiona tus conexiones de WhatsApp y su estado",
    disconnect: "Desconectar",
    refresh: "Actualizar",
    noNumbers: "Aún no hay números. Conecta el primero escaneando un QR.",
    config: "Configuración",
    groups: "Grupos",
    connected: "Conectado",
    disconnectedStatus: "Desconectado",
    connecting: "Conectando...",
    qrPending: "Escanea el QR",

    menusNote: "Los menús se guardan en el negocio de este número — todos los números del mismo negocio pueden usarlos. Envía un menú al contacto escribiendo #menu|slug en el CRM o en el chat de LeadBot. Cuando el cliente toca una opción, se ejecuta el paso que configures (mensaje, otro menú, etiqueta).",
    yourBusiness: "su negocio",
    businessMenus: "Menús del negocio",
    newMenu: "Nuevo menú",
    noMenus: "Aún no hay menús. Crea el primero.",
    optionsCount: "opciones",
    edit: "Editar",
    menuName: "Nombre",
    menuSlug: "Slug (para #menu|...)",
    menuBody: "Mensaje del menú",
    menuTitle: "Título (opcional)",
    menuFooter: "Pie (opcional)",
    menuOptions: "Opciones",
    optionTextPlaceholder: "Texto del botón {{n}} (máx 25 caracteres)",
    actionNone: "Solo registrar",
    actionMessage: "Enviar mensaje",
    actionMenu: "Abrir otro menú",
    optionMessagePlaceholder: "Mensaje que se envía si eligen esta opción",
    nextMenuPlaceholder: "¿Qué menú sigue?",
    optionTagPlaceholder: "Etiqueta en el CRM al elegir (opcional)",
    addOption: "Agregar opción",
    back: "Volver",
    saveMenu: "Guardar menú",
    createMenu: "Crear menú",
    close: "Cerrar",

    smsFallback: "Fallback a SMS (si no tiene WhatsApp)",
    callAutoReply: "Auto-responder llamadas con mensaje",
    typingIndicator: "Indicador de Escritura",
    groupsSupport: "Soporte de Grupos",
    enableAgent: "Habilitar Agente IA",
    enableAgentNote: "Responde solos los mensajes entrantes con el agente/workflow asignado al negocio. La etiqueta ai_off en el CRM lo silencia por contacto.",
    syncOrganic: "Sincronizar mensajes entrantes orgánicos con el CRM",
    syncOrganicNote: "Si está apagado, sólo los mensajes entrantes que pertenezcan a una conversación ya iniciada/vinculada con el CRM se sincronizan. El resto sólo aparecen en LeadBot.",
    numbersUsage: "Números de WhatsApp: <strong>{{used}} / {{max}}</strong>",
    aiMonthShort: "IA del mes",
    trialEndsAt: "tu prueba termina el {{date}}",
    regularizePayment: "regulariza tu pago para reactivar el servicio",
    reactivatePlan: "Reactivar plan",

    generatingQr: "Generando código QR...",
    connectingRealtime: "Conectando en tiempo real...",
    cancel: "Cancelar",
    configTitle: "Configuración",
    configSub: "Configura las opciones para este número de WhatsApp",
    openaiNote: "Tu propia IA: con llave propia, las respuestas corren por tu cuenta (si queda vacío, se usa la IA de la plataforma)",
    claudeNote: "Si la capturas, el agente usa Claude (Anthropic) en vez de OpenAI",
    claudeKey: "Claude API Key (opcional)",
    aiModel: "Modelo IA (opcional)",
    elevenNote: "Para notas de voz con TTS",
    initialTag: "Tag Inicial",
    initialTagNote: "Tag para nuevos contactos",
    invalidTag: "Tag Inválido",
    invalidTagNote: "Se pone solo cuando el número no tiene WhatsApp; sus mensajes salen por SMS",
    smsOnlyTag: "Tag SMS-only",
    smsOnlyTagNote: "Pon este tag a un contacto en el CRM para forzar que SIEMPRE reciba SMS, aunque tenga WhatsApp",
    broadcastDelay: "Retardo de Difusión (segundos)",
    broadcastDelayNote: "segundos entre mensajes de difusión",
    tabVoice: "Voz",
    tabFeatures: "Features",
    tabMenus: "Menús",
    saving: "Guardando...",
    saveChanges: "Guardar cambios",

    businessNoticeTitle: "Importante: Usa WhatsApp Business",
    businessNotice: "Para que la sincronización de contactos funcione correctamente, debes escanear el código QR usando la aplicación WhatsApp Business, no WhatsApp normal. WhatsApp normal oculta los números de teléfono de los remitentes, lo que impide la correcta identificación de contactos en el CRM.",
    loadingSessions: "Cargando sesiones...",
    serviceDown: "Servicio de WhatsApp no disponible",
    serviceDownSub: "El servicio está iniciando o no está disponible temporalmente",
    retryConnection: "Reintentar conexión",
    noWhatsapp: "No hay WhatsApps conectados",
    noWhatsappSub: "Añade tu primer número de WhatsApp para comenzar",
    noNumber: "Sin número asignado",
    connect: "Conectar",

    title: "WhatsApp Gateway",
    selectBusiness: "Selecciona negocio...",
    toastServiceStarted: "Servicio de WhatsApp iniciado",
    toastLoadFailed: "Error al cargar las sesiones de WhatsApp",
    toastConnected: "WhatsApp conectado correctamente",
    toastSessionConnected: "WhatsApp {{phone}} conectado",
    toastGroupJoined: "Agregado al grupo: {{name}}",
    newGroup: "Nuevo grupo",
    toastNameRequired: "El nombre es requerido",
    toastSelectBusiness: "Selecciona un negocio primero",
    toastSessionCreated: "Sesión creada correctamente",
    toastCreateFailed: "Error al crear la sesión",
    toastPlanLimit: "Tu plan no permite más números",
    toastExtendPlan: "Puedes ampliar tu plan aquí",
    viewPlans: "Ver planes",
    toastAlreadyConnected: "Ya está conectado",
    toastQrFailed: "No se pudo cargar el QR. Intenta de nuevo.",
    toastConnectFailed: "Error al conectar WhatsApp",
    toastDisconnected: "WhatsApp desconectado",
    toastDisconnectFailed: "Error al desconectar",
    toastSessionDeleted: "Sesión eliminada",
    toastDeleteFailed: "Error al eliminar la sesión",
    toastConfigSaved: "Configuración guardada",
    toastSaveFailed: "Error al guardar",
    toastConfigSaveFailed: "Error al guardar configuración",
    toastMenusLoadFailed: "No se pudieron cargar los menús",
    toastMenuNeedName: "El menú necesita nombre y slug",
    toastMenuNeedOption: "Agrega al menos una opción con texto",
    toastMenuChainMissing: "La opción \"{{text}}\" activa otro menú pero no elegiste cuál",
    toastMenuSaved: "Menú guardado",
    toastMenuSaveFailed: "Error al guardar el menú",
    toastMenuDeleted: "Menú eliminado",
    toastMenuDeleteFailed: "Error al eliminar el menú",
    toastStartingService: "Intentando iniciar servicio de WhatsApp...",
    toastServiceStartedShort: "Servicio iniciado",
    toastServiceStartFailed: "Error al iniciar servicio",
    toastServerError: "Error al conectar con el servidor",
    menuBroadcast: "Difusión y Búsqueda",
    menuDelete: "Eliminar",
    addDesc: "Crea una nueva conexión de WhatsApp para tu negocio",
    nameLabel: "Nombre",
    namePh: "Ej: WhatsApp Principal",
    priorityLabel: "Prioridad",
    priorityHint: "Los números con menor prioridad se usan primero",
    create: "Crear",
    deleteTitle: "Eliminar sesión",
    deleteDesc: "¿Estás seguro de eliminar la sesión \"{{name}}\"? Esta acción no se puede deshacer.",
    deleting: "Eliminando...",
    qrTitle: "Escanear Código QR",
    qrLive: "Tiempo Real",
    qrDesc: "Abre WhatsApp en tu teléfono, ve a Dispositivos Vinculados y escanea este código",
    tabGeneral: "General",
    tabWebhooks: "Webhooks",
    voiceProcessor: "Procesador de Voz",
    vpNone: "Ninguno",
    webhookMsg: "Webhook de Mensajes",
    webhookMsgNote: "Se dispara cuando llega un mensaje nuevo",
    webhookDisc: "Webhook de Desconexión",
    webhookDiscNote: "Se dispara cuando WhatsApp se desconecta",
    audioTranscription: "Transcripción de Audio",
    showSourceLine: "Mostrar línea de origen en el CRM",
    waCallsTitle: "Llamadas de WhatsApp",
    callsReplyLabel: "Mensaje de auto-respuesta a llamadas",
    callsReplyPh: "Gracias por tu llamada. Por este canal atendemos únicamente por mensaje. ¿En qué podemos ayudarte?",
    callsReplyNote: "Las llamadas no se pueden contestar desde aquí (limitación de WhatsApp Web), pero se anotan solas en el historial del contacto en el CRM y este mensaje se envía al instante. Vacío = mensaje por defecto.",
    groupsConfigTitle: "Configuración de Grupos",
    autoJoin: "Auto-registrar cuando me agregan a un grupo",
    autoJoinNote: "Cuando está activo, los grupos nuevos se registran automáticamente (silenciados por defecto)",
    spintaxTitle: "Spintax Global (anti-spam)",
    spintaxDesc: "Define hasta 6 variables reutilizables. Una variante por línea. Úsalas en cualquier mensaje como ${SPINTAX_1} y cada envío elegirá una variante al azar — mensajes idénticos en masa son la causa #1 de bloqueo.",
    spintaxLocked: "bloqueado",
    spintax1Note: "Saludo de apertura por defecto de la plataforma (no editable) — úsalo como ${SPINTAX_1} al inicio de tus mensajes de campañas y workflows.",
    spintaxInlineNote: "También puedes declarar spintax por mensaje: !/SPINTAX_A/opción 1/opción 2/SPINTAX_A/! y usarla como ${SPINTAX_A}. Y agregar !/DELAY/1000/6000/! al final para esperar 1-6 seg al azar antes de enviar.",
    crmSyncTitle: "Sincronización con el CRM",
    menuNamePh: "Menú principal",
    menuBodyPh: "¿En qué te puedo ayudar?",
  },

  agents: {
    title: "Agents",
    subtitle: "Crea y gestiona tus agentes de conversación IA",
    newAgent: "Nuevo Agente",
    noAgents: "Aún no hay agentes",
    noAgentsSub: "Crea tu primer agente IA para comenzar",
    delete: "Eliminar",
    search: "Buscar agentes...",
    activate: "Activar",
    deactivate: "Desactivar",
    unknown: "Desconocido",
    filterBusiness: "Filtrar por negocio",
    deleted: "Agente eliminado",
    deleteFailed: "Error al eliminar el agente",
    loadFailed: "Error al cargar datos",
    updateFailed: "Error al actualizar el agente",
  },
  kbPage: {
    title: "Knowledge Base",
    subtitle: "Gestiona el conocimiento de tu agente IA con edición en línea",
    newEntry: "Nueva Entrada",
    search: "Buscar entradas...",
    createFirst: "Crea tu primera entrada de knowledge base",
    deleteConfirm: "¿Eliminar esta entrada? No se puede deshacer.",
    created: "Entrada creada",
    deleted: "Entrada eliminada",
    updated: "Entrada actualizada (nueva versión creada)",
    createFailed: "Error al crear la entrada",
    deleteFailed: "Error al eliminar la entrada",
    loadFailed: "Error al cargar datos",
    versionsFailed: "Error al cargar versiones",
    delete: "Eliminar",
    editInline: "Editar en línea",
    versionHistory: "Historial de versiones",
    entryTitle: "Título de la entrada...",
    noEntries: "Aún no hay entradas",
    noMatching: "Sin resultados",
    adjustFilters: "Prueba ajustando los filtros",
    showing: "Mostrando {{shown}} de {{total}} entradas",
  },

  convo: {
    loadFailed: "Error al cargar conversaciones",
    loadOneFailed: "Error al cargar la conversación",
    sendFailed: "Error al enviar el mensaje",
    search: "Buscar...",
    noConversations: "Sin conversaciones",
    noMessages: "Sin mensajes",
    typeMessage: "Escribe un mensaje...",
    unknown: "Desconocido",
  },

  wf: {
    loadFailed: "Error al cargar workflows",
    deleteFailed: "Error al eliminar el workflow",
    deleted: "Workflow eliminado",
    unassigned: "Sin asignar",
    subtitle: "Diseña flujos de automatización visual para tus agentes",
    newWorkflow: "Nuevo Workflow",
    noWorkflows: "Aún no hay workflows",
    noWorkflowsSub: "Crea tu primer workflow para automatizar conversaciones",
  },

  agentEditor: {
    editAgent: "Editar Agente",
    newAgent: "Nuevo Agente",
    tabPersona: "Persona",
    tabKnowledge: "Conocimiento",
    tabTest: "Prueba",
    personaTitle: "Persona del Agente",
    agentName: "Nombre del Agente",
    agentNamePlaceholder: "ej. Asistente de Ventas",
    tone: "Tono",
    personality: "Personalidad",
    personalityPlaceholder: "ej. Servicial y conciso",
    systemPrompt: "System Prompt",
    systemPromptPlaceholder: "Instrucciones para el agente IA...",
    businessContext: "Contexto del Negocio",
    businessContextPlaceholder: "Describe el negocio, productos, servicios...",
    kbTitle: "Base de Conocimiento",
    kbHint: "Selecciona las entradas de knowledge base a asociar con este agente",
    kbEmpty: "Sin entradas KB. Crea algunas primero.",
    kbSearch: "Buscar entrada...",
    testTitle: "Chat de Prueba",
    saveFirst: "Guarda el agente primero para probar el chat",
    agentResponse: "Respuesta del agente:",
    testPlaceholder: "Escribe un mensaje de prueba...",
    saving: "Guardando...",
    saveAgent: "Guardar Agente",
    cancel: "Cancelar",
    selectAll: "Seleccionar todas",
    deselectAll: "Quitar todas",
    noResults: "Sin resultados para \"{{q}}\".",
    toneProfessional: "Profesional",
    toneFriendly: "Amigable",
    toneCasual: "Casual",
    toneFormal: "Formal",
    toastLoadFailed: "Error al cargar los datos",
    toastNameRequired: "El nombre del agente es requerido",
    toastUpdated: "Agente actualizado",
    toastCreated: "Agente creado",
    toastSaveFailed: "Error al guardar el agente",
    toastSaveFirst: "Guarda el agente primero para probar",
    toastTestFailed: "La prueba falló",
  },

  builder: {
    namePlaceholder: "Nombre del workflow...",
    active: "Activo",
    draft: "Borrador",
    assignAgent: "Asignar agente...",
    deactivate: "Desactivar",
    activate: "Activar",
    deleteNode: "Eliminar Nodo",
    nameRequired: "El workflow necesita nombre",
    saveFirstActivate: "Guarda el workflow antes de activarlo",
    saving: "Guardando...",
    save: "Guardar",

    triggers: "Disparadores",
    triggersNote: "Sin reglas = workflow por defecto del agente. Con reglas, se dispara solo cuando matchean (solo si la conversación no tiene otro workflow en curso).",
    ruleTag: "🏷 Etiqueta",
    ruleKeyword: "🔑 Palabra clave",
    ruleChannel: "📱 Canal (número)",
    ruleNewContact: "✨ Contacto nuevo",
    has: "Tiene",
    notHas: "No tiene",
    exact: "Exacta",
    startsWith: "Empieza con",
    keywordPlaceholder: "precio",
    chooseNumber: "Elige el número",
    newContactNote: "Se dispara solo si es la primera conversación del contacto.",
    ifSeveral: "Si hay varias:",
    any: "Cualquiera",
    all: "Todas",
    priority: "Prioridad:",
    priorityNote: "Si dos workflows matchean, gana la de prioridad MAYOR. Ej: campaña FB (prioridad 20) le gana a la general (prioridad 10) — pero si no hay regla que matchee, corre el workflow default.",
    addRule: "+ Agregar regla",

    operator: "Operador",
    equals: "Igual a",
    notEquals: "Distinto de",
    contains: "Contiene",
    greaterThan: "Mayor que",
    lessThan: "Menor que",
    calendar: "Calendario",
    enterIdManually: "Ingresar ID manualmente...",
    bookingMessage: "Mensaje de Agenda",
    method: "Método",
    duration: "Duración",
    seconds: "Segundos",
    minutes: "Minutos",
    action: "Acción",
    addTag: "Agregar Etiqueta",
    removeTag: "Quitar Etiqueta",
    tagName: "Nombre de Etiqueta",
    endAction: "Acción Final",
    endComplete: "Marcar conversación completada",
    endHandoff: "Pasar a humano",
    endPause: "Pausar conversación",
    finalMessage: "Mensaje Final (opcional)",
    endAddTag: "Agregar Etiqueta al Final (opcional)",

    objectiveType: "Tipo de Objetivo",
    giveInfo: "Dar Info",
    gatherInfo: "Recolectar Info",
    dataToCollect: "Dato a Recolectar",
    selectField: "Selecciona el dato...",
    customField: "Campo personalizado...",
    customFieldName: "Nombre del Campo",
    customFieldPlaceholder: "ej. Tipo de propiedad",
    customCrmField: "Campo CRM personalizado...",
    botPrompt: "Bot Prompt",
    botPromptNote: "Escribe natural — el bot formulará la pregunta usando tu prompt como guía",
    validation: "Validación",
    noValidation: "Sin validación",
    validEmail: "Debe ser email válido",
    validPhone: "Debe ser teléfono válido",
    validNumber: "Debe ser un número",
    notEmpty: "No puede estar vacío",
    prefillTitle: "Cuando el contacto ya tiene este dato",
    alwaysAsk: "Preguntar siempre",
    alwaysAskDesc: "Ignora el dato existente, pregunta de nuevo",
    confirmExisting: "Confirmar existente",
    confirmExistingDesc: "Muestra el dato y pide confirmar o corregir",
    skipIfFilled: "Saltar si está lleno",
    skipIfFilledDesc: "Omite automáticamente, pasa al siguiente paso",
    confirmPrompt: "Prompt de Confirmación (opcional)",
    confirmPromptNote: "Usa {value} para referenciar el dato existente. El bot pedirá confirmar o dar un valor nuevo.",
    informPrompt: "Prompt de Información",
    informPromptNote: "El bot usará tu Knowledge Base + este prompt para dar la información",


    toastLoadFailed: "Error al cargar el workflow",
    toastNodeDeleted: "Nodo eliminado",
    toastSaved: "Workflow guardado",
    toastCreated: "Workflow creado",
    toastSaveFailed: "Error al guardar el workflow",
    toastStatusFailed: "Error al cambiar el estado del workflow",
    nodesHeader: "Nodos",
    paletteTip: "Tip: selecciona un nodo o conexión y presiona Delete/Backspace para eliminarlo",
    fromSubaccount: "De tu cuenta ({{count}})",
    mapCrmField: "Mapear a campo del CRM...",
    maxTurns: "Máx. Turnos",
    fieldLabel: "Campo",
    valueLabel: "Valor",
    selectCalendarPh: "Selecciona un calendario...",
    calendarIdPh: "ID del Calendario",
    calendarLoadFailed: "No se pudieron cargar los calendarios automáticamente - pega el ID del Calendario de tu CRM",
    unit: "Unidad",
    hours: "Horas",
    days: "Días",
    fieldFullName: "Nombre completo",
    fieldFirstName: "Nombre",
    fieldLastName: "Apellido",
    fieldPhone: "Teléfono",
    fieldAddress: "Dirección",
    fieldCity: "Ciudad",
    fieldState: "Estado / Provincia",
    fieldZip: "Código Postal",
    fieldCompany: "Empresa",
    fieldBudget: "Presupuesto",
    fieldServiceInterest: "Servicio de Interés",
    fieldPreferredDate: "Fecha Preferida",
    endHandoffNote: "La IA dejará de responder y notificará a los agentes humanos",
    endPauseNote: "La IA se pausará pero puede reactivarse",
    endCompleteNote: "El workflow se completará y la IA se detendrá",
    finalMessagePh: "ej. ¡Gracias por tu tiempo! Nuestro equipo te contactará pronto.",
    endAddTagNote: "Esta etiqueta se agregará al contacto cuando termine el workflow",
  },

  nodes: {
    objective: "Objetivo",
    conversation: "Conversación",
    condition: "Condición",
    booking: "Agenda",
    delay: "Retraso",
    tag: "Agregar/Quitar Etiqueta",
    end: "Fin del Workflow",
  },

  agency: {
    loading: "Cargando panel de agencia...",
    forbiddenNote: "El plan Agencia te permite crear subcuentas para revender LeadBot a tus propios clientes, cada una con su enlace de activación whitelabel.",
    whitelabel: "Marca blanca",
    whitelabelNote: "Cuando tus clientes abran su enlace de activación, verán tu marca (nombre y logo) en lugar de LeadBot — el panel se siente 100% tuyo.",
    brandName: "Nombre de tu marca",
    brandLogo: "URL de tu logo",
    brandNamePlaceholder: "Ej. Studio MX",
    saving: "Guardando...",
    saveBrand: "Guardar marca",
    preview: "Vista previa:",
    subtitle: "Crea subcuentas para tus clientes y comparte su enlace de activación — cada cliente solo ve lo suyo, sin marca de LeadBot.",
    subaccounts: "Subcuentas",
    linesAssigned: "Líneas asignadas",
    linesAvailable: "Líneas disponibles",
    newSub: "Nueva subcuenta",
    clientName: "Nombre del cliente o negocio",
    whatsappLines: "Líneas de WhatsApp",
    clientNamePlaceholder: "Ej. Clínica Dental López",
    createSub: "Crear subcuenta",
    noSubs: "Aún no tienes subcuentas. Crea la primera arriba.",
    name: "Nombre",
    lines: "Líneas",
    linesInUse: "líneas en uso",
    copyActivation: "Copiar enlace de activación",
    howToTitle: "Cómo lo usa tu cliente:",
    howTo: "le compartes su enlace de activación (pégalo tal cual, o como Custom Menu Link dentro de tu agencia de GoHighLevel para que aparezca en el menú lateral de su subcuenta). Al abrirlo entra directo a su panel, conecta su QR y solo ve su negocio.",
    toastBrandSaved: "Marca guardada — tus clientes la verán en su panel",
    toastLinkCopied: "Enlace copiado — compártelo con tu cliente",
    toastExtendPlan: "Puedes ampliar tu plan aquí",
  },

  saas: {
    accessDenied: "Acceso Denegado",
    superAdminRequired: "Se requiere acceso de Super Admin",
    title: "Gestión SaaS",
    subtitle: "Gestiona agencias, planes y suscripciones",
    refresh: "Actualizar",
    totalAgencies: "Agencias Totales",
    activeAgencies: "Agencias Activas",
    mrr: "MRR",
    subscriptionPlans: "Planes de Suscripción",
    newPlan: "Nuevo Plan",
    agencies: "Agencias",
    newAgency: "Nueva Agencia",
    editAgency: "Editar Agencia",
    createAgency: "Crear Nueva Agencia",
    editPlan: "Editar Plan",
    createPlan: "Crear Nuevo Plan",
    waNumbersTotal: "Números de WhatsApp (total)",
    realLimits: "Límites reales (billing)",
    aiCreditsPerMonth: "Créditos IA por mes (0 = ilimitado)",
  },
  cmds: {
    title: "Comandos de WhatsApp",
    subtitle: "Respuestas automáticas con /comando",
    newCommand: "Nuevo Comando",
    createCommand: "Crear Comando",
    bannerTitle: "Sistema de Comandos",
    bannerText: "Cuando un contacto envía un mensaje que comienza con /, se busca el comando y se responde automáticamente. Puedes agregar tags y disparar webhooks para crear automatizaciones en el CRM.",
    listTitle: "Comandos Configurados",
    listSub: "Lista de comandos disponibles para tus contactos de WhatsApp",
    loading: "Cargando comandos...",
    emptyTitle: "No hay comandos configurados",
    emptySub: "Crea tu primer comando para respuestas automáticas",
    inactive: "Inactivo",
    uses: "usos",
    editTitle: "Editar Comando",
    newTitle: "Nuevo Comando",
    modalSub: "Configura la respuesta automática y las acciones del comando",
    triggerLabel: "Comando (sin /)",
    triggerPh: "precio, horario, info...",
    triggerHint: "Los usuarios escribirán /{{cmd}}",
    triggerFallback: "comando",
    responseLabel: "Respuesta",
    responsePh: "El mensaje que se enviará automáticamente...",
    addTagsLabel: "Agregar Tags",
    tagsHint: "Separados por coma",
    removeTagsLabel: "Remover Tags",
    webhookLabel: "Webhook URL (opcional)",
    webhookHint: "Se enviará POST con datos del contacto cuando se use el comando",
    scopeLabel: "Alcance",
    scopeAll: "Todos",
    scopeGroups: "Solo Grupos",
    scopeIndividual: "Solo Individual",
    activeLabel: "Activo",
    cancel: "Cancelar",
    saveChanges: "Guardar Cambios",
    toastLoadFailed: "Error al cargar los comandos",
    toastRequired: "El comando y la respuesta son requeridos",
    toastNoBusiness: "No se encontró el negocio",
    toastUpdated: "Comando actualizado",
    toastCreated: "Comando creado",
    toastSaveFailed: "Error al guardar el comando",
    toastDeleted: "Comando eliminado",
    toastDeleteFailed: "Error al eliminar el comando",
    confirmDelete: "¿Eliminar el comando /{{trigger}}?",
  },
  biz: {
    title: "Businesses",
    subtitle: "Gestiona las ubicaciones y configuraciones de tus negocios",
    addBusiness: "Agregar Negocio",
    editBusiness: "Editar Negocio",
    createBusiness: "Crear Negocio",
    basicInfo: "Información Básica",
    nameLabel: "Nombre del Negocio *",
    namePh: "ej. The Brokers Real Estate",
    descLabel: "Descripción",
    descPh: "Breve descripción del negocio",
    ghlConfig: "Configuración de GoHighLevel",
    locationIdHint: "Se encuentra en GHL Settings → Business Profile",
    apiKeyLabel: "GHL API Key (Opcional)",
    apiKeyHint: "Déjalo vacío para usar la API key global. Úsalo para integraciones por negocio.",
    doctorTitle: "GHL Connection Doctor",
    doctorDesc: "Ejecuta un diagnóstico completo de la conexión con GoHighLevel para este negocio.",
    doctorRun: "Ejecutar GHL Doctor",
    doctorRunning: "Diagnosticando...",
    oauthConnect: "Conectar OAuth Marketplace",
    oauthGenerating: "Generando URL...",
    oauthStatus: "Estado OAuth",
    connected: "Conectado",
    notConnected: "No Conectado",
    agentCalendar: "Agente y Calendario",
    defaultAgent: "Agente por Defecto",
    selectAgent: "Selecciona agente...",
    none: "Ninguno",
    defaultCalendar: "Calendario por Defecto",
    selectCalendar: "Selecciona calendario...",
    calendarField: "Campo Personalizado de Calendario",
    calendarFieldHint: "Campo personalizado de GHL que contiene el ID de calendario por contacto",
    openaiTitle: "OpenAI API Key (Opcional)",
    bizApiKeyLabel: "API Key específica del negocio",
    bizApiKeyPh: "sk-proj-... (vacío = usar llave global)",
    bizApiKeyHint: "Si se define, este negocio usará su propia llave de OpenAI en vez de la global",
    embedTitle: "URL Embed para GHL",
    embedLabel: "Custom Menu Link para GHL",
    embedCopied: "¡URL embed copiada!",
    embedRegenerate: "Regenerar Token",
    embedTokenGenerated: "Token embed generado",
    embedTokenFailed: "Error al generar el token",
    embedGenerate: "Generar URL Embed",
    embedHint: "Genera una URL segura para embeber LeadBot en el menú personalizado de GHL",
    embedUseHint: "Usa esta URL en GHL Settings → Custom Menu Links → \"Open as embedded page (iFrame)\"",
    cancel: "Cancelar",
    updateBusiness: "Actualizar Negocio",
    createBusinessBtn: "Crear Negocio",
    emptyTitle: "Aún no hay negocios",
    emptyAdmin: "Crea tu primer negocio para comenzar",
    emptyUser: "No hay negocios disponibles",
    statusActive: "activo",
    agentsCount: "Agentes",
    ghlNo: "Sin GHL",
    calYes: "Cal",
    calNo: "Sin Cal",
    clientView: "Vista de cliente",
    clientViewSim: " (simulada)",
    removePlan: "Quitar plan",
    removePlanSim: "Quitar plan simulado",
    simPersonal: "Simular Personal",
    simAgency: "Simular Small Agency",
    whitelabelLink: "Enlace whitelabel (para su menú en el CRM)",
    activationCopied: "Enlace de activación copiado",
    webhookCopied: "¡URL de webhook copiada!",
    confirmDelete: "¿Eliminar \"{{name}}\"? Esto no se puede deshacer.",
    toastAdminRequired: "Se requiere acceso de administrador",
    toastLoadFailed: "Error al cargar los datos",
    toastNoBusiness: "No se seleccionó negocio",
    toastDoctorOk: "GHL Doctor: conexión saludable",
    toastDoctorIssues: "GHL Doctor: se encontraron problemas",
    toastDoctorError: "Error al ejecutar el diagnóstico",
    toastOauthOpening: "Abriendo instalación OAuth en GHL Marketplace",
    toastOauthFailed: "No se pudo generar la URL OAuth",
    toastNameRequired: "El nombre del negocio es requerido",
    toastUpdated: "Negocio actualizado",
    toastCreated: "Negocio creado",
    toastSaveFailed: "Error al guardar el negocio",
    toastDeleted: "Negocio eliminado",
    toastDeleteFailed: "Error al eliminar el negocio",
    toastSimCleared: "Plan simulado eliminado",
    toastSimSet: "Plan {{plan}} simulado (activo)",
    toastSimFailed: "No se pudo simular el plan",
  },
  usr: {
    title: "Gestión de Usuarios",
    subtitle: "Administra los usuarios y permisos de la plataforma",
    addUser: "Agregar Usuario",
    searchPh: "Buscar usuarios...",
    editUser: "Editar Usuario",
    createUser: "Crear Usuario",
    fullName: "Nombre Completo",
    role: "Rol",
    roleUser: "Usuario (Admin de Negocio)",
    roleAdmin: "Admin (Super Admin)",
    roleHint: "Los Super Admins pueden gestionar todos los negocios. Los Admins de Negocio están limitados a un negocio.",
    assignedBusiness: "Negocio Asignado *",
    selectBusiness: "Selecciona negocio...",
    businessHint: "El usuario sólo tendrá acceso a los recursos de este negocio.",
    cancel: "Cancelar",
    updateUser: "Actualizar Usuario",
    createUserBtn: "Crear Usuario",
    emptyTitle: "No se encontraron usuarios",
    emptyCreate: "Crea tu primer usuario",
    emptySearch: "Intenta ajustar tu búsqueda",
    inactive: "Inactivo",
    joined: "Se unió",
    statsTotal: "usuarios totales",
    statsAdmins: "admins",
    statsActive: "activos",
    toastAdminRequired: "Se requiere acceso de administrador",
    toastLoadFailed: "Error al cargar los datos",
    toastUpdated: "Usuario actualizado",
    toastUpdateFailed: "Error al actualizar el usuario",
    toastRequired: "Completa todos los campos requeridos",
    toastNeedBusiness: "Los usuarios regulares deben tener un negocio asignado",
    toastCreated: "Usuario creado",
    toastCreateFailed: "Error al crear el usuario",
    toastActivated: "Usuario activado",
    toastDeactivated: "Usuario desactivado",
    toastStatusFailed: "Error al actualizar el estado del usuario",
  },
  groups: {
    title: "Grupos de WhatsApp",
    noNumber: "Sin número",
    extract: "Extraer Grupos",
    reextract: "Re-extraer Grupos",
    extracting: "Extrayendo...",
    muteAll: "Silenciar Todos",
    extractLegend: "Al dar clic en Extraer Grupos, debes volver a entrar manualmente a cada grupo con el botón Entrar para activar su sincronización.",
    bannerTitle: "Tres estados por grupo",
    bannerText: "Sin entrar: nada llega al CRM (default). Entrar: los mensajes llegan al hilo del grupo en el CRM. Silenciar (campana): los mensajes SIGUEN llegando al CRM, pero se marcan como leídos para que la app no te notifique a cada rato. Salir: dejan de llegar. Los grupos nunca activan menús ni al agente IA.",
    totalGroups: "Total Grupos",
    mutedCount: "Silenciados",
    soundCount: "Con sonido",
    listTitle: "Grupos",
    listSub: "Gestiona las notificaciones y el procesamiento de IA por grupo",
    loading: "Cargando grupos...",
    emptyTitle: "No hay grupos extraídos",
    emptySub: "Haz clic en \"Extraer Grupos\" para importar los grupos de este WhatsApp",
    badgeActiveSound: "Activo · con sonido",
    badgeActiveMuted: "Activo · silenciado",
    badgeAiOn: "IA Activa",
    participants: "{{count}} participantes",
    participants_plural: "{{count}} participantes",
    messages: "{{count}} mensajes",
    messages_plural: "{{count}} mensajes",
    lastMessage: "Último mensaje",
    noActivity: "Sin actividad",
    enter: "Entrar",
    leave: "Salir",
    titleMute: "Silenciar: los mensajes siguen llegando al CRM pero sin notificar",
    titleUnmute: "Activar sonido: los mensajes llegan y notifican",
    settingsTitle: "Configuración del Grupo",
    muteGroup: "Silenciar Grupo",
    muteGroupDesc: "Sin alertas visuales. La sincronización del grupo sigue activa.",
    aiOffDesc: "El agente NO responde en este grupo",
    aiOnDesc: "El agente responde en este grupo",
    mutedBanner: "Grupo silenciado: no verás alertas, pero los mensajes siguen llegando y sincronizando.",
    cancel: "Cancelar",
    saveChanges: "Guardar Cambios",
    toastLoadFailed: "Error al cargar los grupos",
    toastExtracting: "Extrayendo grupos de WhatsApp...",
    toastExtracted: "Se extrajeron {{count}} grupos",
    toastExtractFailed: "Error al extraer grupos",
    toastSaved: "Configuración guardada",
    toastSaveFailed: "Error al guardar configuración",
    toastAllMuted: "Todos los grupos silenciados",
    toastAllUnmuted: "Todos los grupos activados",
    toastUpdateFailed: "Error al actualizar el grupo",
    toastJoined: "Entraste al grupo \"{{name}}\"",
    toastJoinFailed: "Error al entrar al grupo",
    toastLeft: "Saliste del grupo \"{{name}}\"",
    toastLeaveFailed: "Error al salir del grupo",
    toastMuted: "\"{{name}}\" silenciado: los mensajes siguen llegando al CRM sin notificar",
    toastUnmuted: "\"{{name}}\" con sonido: los mensajes llegan y notifican",
  },

  bcast: {
    title: "Búsqueda y Difusión",
    noNumber: "Sin número",
    tabBroadcast: "Difusión a Grupos",
    tabSearch: "Buscar Mensajes",
    broadcastTitle: "Enviar Mensaje a Múltiples Grupos",
    broadcastSub: "Selecciona los grupos y escribe el mensaje que quieres publicar",
    messageLabel: "Mensaje",
    messagePh: "Ej: Busco casa en venta en zona norte...",
    selectGroups: "Seleccionar Grupos ({{sel}}/{{total}})",
    selectAll: "Seleccionar Todos",
    deselectAll: "Deseleccionar Todos",
    noGroups: "No hay grupos disponibles. Extrae los grupos primero.",
    participants: "{{count}} participantes",
    participants_plural: "{{count}} participantes",
    messages: "{{count}} mensajes",
    messages_plural: "{{count}} mensajes",
    activeBadge: "Activo",
    delayLabel: "Retardo entre mensajes",
    delayHint: "segundos (mín: 1s, recomendado: 2-5s)",
    delayNote: "Un retardo más largo reduce el riesgo de bloqueo por WhatsApp. Para {{count}} grupos, tiempo estimado: ~{{secs}}s",
    sending: "Enviando...",
    sendTo: "Enviar a {{count}} grupo(s)",
    sentCount: "{{count}} enviados",
    failedCount: "{{count}} fallidos",
    failedLabel: "Fallidos",
    searchTitle: "Buscar en Mensajes",
    searchSub: "Busca texto dentro de los mensajes guardados de tus grupos y contactos",
    searchPh: "Ej: casa en renta malecon...",
    allGroups: "Todos los grupos",
    searchBtn: "Buscar",
    searching: "Buscando...",
    noResults: "No hay resultados",
    noResultsHint: "Escribe algo para buscar en los mensajes",
    toastSearchEmpty: "Escribe algo para buscar",
    toastFound: "Se encontraron {{count}} mensajes",
    toastSearchFailed: "Error al buscar",
    toastSelectGroups: "Selecciona al menos un grupo",
    toastWriteMessage: "Escribe un mensaje",
    toastSent: "Mensaje enviado a {{count}} grupos",
    toastFailed: "{{count}} grupos fallaron",
    toastSendFailed: "Error al enviar mensajes",
  },
  stg: {
    title: "Configuración",
    subtitle: "Configura la IA y la integración con GoHighLevel",
    tabCredentials: "Credenciales",
    tabGuide: "Guía de configuración",
    oauthTitle: "Conexión con GoHighLevel",
    connectedBadge: "Conectado",
    oauthWarnTitle: "Paso obligatorio:",
    oauthWarnText: "sin esta conexión tus mensajes de WhatsApp no llegan a tu CRM.",
    oauthStep1: "Haz clic en Conectar con GoHighLevel.",
    oauthStep2: "En la ventana que se abre, elige tu cuenta y autoriza la app.",
    oauthStep3: "Listo — tu cuenta queda vinculada automáticamente (la app reconoce tu cuenta sola, sin tokens ni IDs manuales).",
    oauthLinkedVia: "Tu cuenta está vinculada vía",
    viaToken: "token privado",
    syncActive: "El sync de mensajes está activo.",
    oauthOpening: "Abriendo GoHighLevel...",
    oauthReconnect: "Reconectar / cambiar cuenta",
    oauthConnectBtn: "Conectar con GoHighLevel",
    marketplaceNote: "Es la misma app del Marketplace de GoHighLevel — también puedes instalarla desde ahí, el resultado es idéntico.",
    toastAuthorize: "Autoriza la app en la ventana de GoHighLevel; al terminar ciérrala y vuelve aquí",
    toastConnectFailed: "No se pudo iniciar la conexión con GoHighLevel",
    embedTitle: "Tu cuenta está gestionada por tu proveedor",
    embedDesc1: "La conexión con tu CRM y las credenciales principales las administra tu proveedor de servicio — no necesitas configurar nada aquí.",
    embedDesc2: "Para ajustar la IA de tu número (tu propia llave de OpenAI o Claude), ve a",
    embedPath: "WhatsApp → menú ⋮ de tu número → Configuración → General",
    envConfigured: "API key configurada por entorno. Puedes sobreescribirla abajo para negocios específicos.",
    globalOpenai: "OpenAI API Key Global",
    envKeyPh: "Usando llave de entorno (override opcional)",
    getKeyFrom: "Obtén tu API key en",
    claudeKeyLabel: "Claude API Key global (opcional)",
    claudeKeyPh: "sk-ant-... (si la capturas, el default global es Claude)",
    aiModelLabel: "Modelo IA global (opcional)",
    aiModelPh: "gpt-4o-mini / claude-sonnet-4-5",
    priorityLabel: "Prioridad:",
    priorityText: "llave del número (Config. de WhatsApp) → llave del negocio → esta llave global → plataforma",
    webhookDesc: "Usa esta URL en la acción webhook 'Process Message' de tu workflow de GHL",
    webhookCopied: "¡URL de webhook copiada!",
    ghlCredsTitle: "Credenciales API de GHL",
    ghlEnvConfigured: "Credenciales de GHL configuradas por entorno.",
    pitLabel: "Private Integration API Key",
    locationLabel: "Location ID por Defecto",
    locationPh: "Ingresa tu GHL Location ID",
    doctorTitle: "GHL Connection Doctor",
    doctorDesc: "Ejecuta un diagnóstico completo (credenciales, location, ping API, webhook) y corrige rápido problemas de conexión.",
    selectBizLabel: "Seleccionar Business para diagnosticar",
    selectBizPh: "Selecciona un business...",
    selectBizHint: "Selecciona un business para ejecutar el diagnóstico y conectar OAuth.",
    sinGhl: "(Sin GHL)",
    runDoctor: "Ejecutar GHL Doctor",
    doctorRunning: "Diagnosticando...",
    oauthConnect: "Conectar OAuth Marketplace",
    oauthGenerating: "Generando URL...",
    oauthStatus: "Estado OAuth",
    configured: "Configurado",
    missing: "Faltante",
    connected: "Conectado",
    notConnected: "No Conectado",
    customFieldsTitle: "Campos Personalizados de GHL",
    customFieldsWarn: "Crea estos campos personalizados en tu cuenta de GHL (Settings > Custom Fields) antes de conectar.",
    botResponseLabel: "Bot Response Field Key",
    botResponseHint: "GHL usa {{contact.salesbot_response}} para enviar la respuesta del bot",
    goalsLabel: "Goals Accomplished Field Key",
    goalsHint: "Registra qué objetivos ha completado el bot",
    statusTitle: "Estado de la Integración",
    labelResponse: "Campo de Respuesta",
    statusNotSet: "Sin configurar",
    saving: "Guardando...",
    saveSettings: "Guardar Configuración",
    toastSaved: "Configuración guardada",
    toastSaveFailed: "Error al guardar la configuración",
    toastDoctorOk: "GHL Doctor: conexión saludable",
    toastDoctorIssues: "GHL Doctor: se encontraron problemas",
    toastDoctorFailed: "No se pudo ejecutar el diagnóstico GHL",
    toastOauthOpening: "Abriendo instalación OAuth en GHL Marketplace",
    toastOauthFailed: "No se pudo generar la URL OAuth",
    step1Title: "Paso 1:",
    step1Name: "Conecta tu cuenta del CRM",
    g1s1: "Ve a la pestaña Credenciales y presiona 'Conectar OAuth Marketplace'.",
    g1s2: "Autoriza la instalación de LeadBot en la cuenta que quieras usar.",
    g1s3: "Al volver, la cuenta queda conectada automáticamente — no necesitas copiar claves manualmente.",
    step2Title: "Paso 2:",
    step2Name: "Selecciona LeadBot como proveedor de telefonía",
    required: "OBLIGATORIO",
    g2s1: "En el CRM, ve a Configuración → Números de teléfono y haz clic en tu número.",
    g2s2: "Abre la pestaña 'Proveedor de telefonía' (Ajustes adicionales).",
    g2s3: "Elige 'LeadBot Gateway' en lugar de 'Lead Connector' y presiona Guardar.",
    g2s4: "Verifica que LeadBot Gateway quede marcado como 'Por defecto'.",
    g2Warn1Strong: "Sin este paso los mensajes no salen por WhatsApp.",
    g2Warn1Text: "Todo (conversaciones manuales, workflows y envíos masivos) pasa por LeadBot una vez que es el proveedor seleccionado.",
    g2Warn2: "Esta pantalla solo la ven los propietarios y administradores de la agencia. Si algún día desinstalas y reinstalas la app en la cuenta, este paso hay que repetirlo.",
    step3Title: "Paso 3:",
    step3Name: "Conecta tu número de WhatsApp",
    g3s1: "En LeadBot, entra a la sección WhatsApp y presiona 'Añadir WhatsApp'.",
    g3s2: "Escanea el código QR con la app WhatsApp Business (no WhatsApp normal).",
    g3s3: "Cuando el estado cambie a 'Conectado', ya puedes enviar y recibir mensajes.",
    g3NotePre: "Si tienes varios números, agrégalos todos aquí — el orden en que los conectas define su prioridad (puedes cambiarla por conversación con el comando",
    g3NotePost: ").",
    step4Title: "Paso 4:",
    step4Name: "Comandos, botones y menús",
    g4Text: "Puedes enviar botones, listas, ubicaciones, notas de voz y menús con secuencias escribiendo comandos directamente en la conversación. Toda la sintaxis con ejemplos listos para copiar está en:",
    g4Btn: "Abrir documentación de comandos",
    cfTitle: "Campos personalizados en el CRM",
    cfDescPre: "Crea estos",
    cfDescStrong: "campos personalizados",
    cfDescPost: "en tu cuenta (Configuración > Campos personalizados > Contacto), solo si usas el bot IA:",
    cfBotStrong: "El bot está activado por defecto.",
    cfBotTextPre: "No necesitas la etiqueta 'ai_on'. El bot solo se desactiva cuando el contacto tiene la etiqueta",
    cfBotTextPost: "Para reactivarlo, simplemente quita la etiqueta.",
    cf1desc: "Campo de texto - guarda la respuesta del bot",
    cf2desc: "Campo de texto - registra los objetivos cumplidos",
    cf3desc: "Campo de texto - registra el canal (SMS, WhatsApp, etc.)",
    legacyTitle: "Automatización avanzada (legado)",
    legacyDesc: "Workflows del CRM para el bot IA clásico por campos personalizados. NO son necesarios para enviar ni recibir WhatsApp — solo si usas ese flujo de bot.",
    wf1Title: "Workflow 1:",
    wf1s1: "Agrega disparadores 'Customer Replied' para cada canal (WhatsApp, SMS, Email, Instagram, Facebook, Chat, GMB)",
    wf1s2: "Agrega una acción 'Contact Changed' que guarde el historial del mensaje",
    wf1s3: "Agrega una rama/switch que revise qué disparador se activó",
    wf1s4: "En cada rama: actualiza el campo 'last_communication_type' con el nombre del canal (ej. 'SMS', 'WhatsApp')",
    wf1s5: "Agrega un filtro para mensajes 'stop' / 'no me interesa' → añade la etiqueta 'ai_off'",
    wf2Title: "Workflow 2:",
    legacyBadge: "Legado",
    wf2s1: "Agrega disparadores 'Customer Replied' para todos los canales",
    wf2s2: "Agrega condición: si 'Etiquetas' NO incluye 'ai_off' → continuar; si no → FINAL",
    wf2s3: "Agrega una acción Webhook (POST) con esta configuración:",
    wf2s4: "Opcionalmente agrega un temporizador de seguimiento (dispara el Workflow: Follow Up 1 Day)",
    wf3Title: "Workflow 3:",
    wf3s1: "Agrega el disparador 'Bot Replied' (se activa cuando salesbot_response se actualiza)",
    wf3s2: "Agrega condición: si 'Etiquetas' NO incluye 'ai_off'",
    wf3s3: "Agrega una rama de verificación de canal basada en 'last_communication_type'",
    wf3s4: "Para cada canal, agrega la acción de envío (SMS, WhatsApp, Messenger, etc.) con el mensaje:",
    wf4Title: "Workflow 4:",
    optionalBadge: "Opcional",
    wf4s1: "Agrega un temporizador de espera de 1 día",
    wf4s2: "Verifica que la etiqueta 'ai_off' NO esté presente",
    wf4s3: "Envía un webhook POST a la misma URL con:",
    flowTitle: "Flujo completo",
    flow1: "El cliente responde",
    flow2: "Workflow 2 del CRM",
    flow3: "Webhook a LeadBot",
    flow4: "La IA genera la respuesta",
    flow5: "Actualiza salesbot_response",
    flow6: "Workflow 3 del CRM",
    flow7: "Envía por el canal correcto",
  },
  waDocs: {
    back: "Volver",
    title: "Documentación y manual de uso",
    subtitle: "Comandos de mensajería, configuración de tus números y controles de grupos, menús y agente IA",
  },
};
